import { Component, ComponentFactoryResolver, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditComponent, FormStorage, UserStorage, Role } from '@scisys-uim/uim-common';
import { CrudEditorParentService, CrudEditorSelfService } from '@scisys-uim/uim-common';


@Component({
  selector: 'app-role-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],

  encapsulation: ViewEncapsulation.None,
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class RoleEditorComponent extends CrudEditComponent<Role, string> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}






